import apiCall from "../../api/crentAPI";
import dollarsToCents from "dollars-to-cents";
import store from "@/store";
import { getPayRoutes } from "@/constants/getRoutes";
import {indexOf} from "core-js/internals/array-includes";
const ENV =
  process.env.NODE_ENV === "staging" || process.env.NODE_ENV === "development"
    ? "ORM_" + process.env.VUE_APP_CUSTOMER_NAME + "_"
    : "ORM_";


function getTotalPriceFromEndPositions(endpositions) {
  return endpositions?.find((position) => position.rate === "ES.")?.total_price;
}


function getPaymentAmount(endpositions) {
  if (process.env.VUE_APP_DEMO === "true") {
    return 111;
  }
  return dollarsToCents(getTotalPriceFromEndPositions(endpositions));
}


const state = () => ({});
const getters = {
  GET_ORDER: (state) =>
    state.payment ||
    JSON.parse(sessionStorage.getItem(ENV + "concardisPayment")) || JSON.parse(sessionStorage.getItem(ENV + "computopPayment")),
};
const actions = {
  async GET_CONCARDIS_MERCHANDID() {
    const stationId = await store.getters["userSession/GET_STATION"];
    let result = "";
    await apiCall.getConcardis(
      `/api/rent/payment/${stationId}/configuration`,
      "",
      (response) => {
        if (response.status === 200) {
          result = {
            merchant_id: response.data["merchant_id"],
            payment_provider: response.data["payment_provider"],
            client_key: response.data["client_key"],
          };
        } else {
          result = "error";
        }
      }
    );
    return result;
  },
  async MAKE_ORDER({ commit }) {
    const stationId = await store.getters["userSession/GET_STATION"];
    const reservation = await store.getters["reservation/GET_RESERVATION"];
    const endpositions = reservation.end_positions;
    const amount = getPaymentAmount(endpositions);
    const bookingPayload = await store.getters["reservation/GET_BOOKING_PAYLOAD"];

    console.log(bookingPayload, 'bookingPayload')

    const payload = {
      initialAmount: amount,
      currency: "EUR",
      transactionType: "DEBIT",
      ipAddress: null,
      async: await getPayRoutes(),
      terms: Date.now(),
      privacy: Date.now(),
      bookingData: btoa(JSON.stringify(bookingPayload))
    };
    let order = "";
    await apiCall.postConcardis(
      `/api/rent/payment/${stationId}/orders`,
      payload,
      (result) => {
        order = result;
        if (result.status === 200) {
          commit("MUTATE_PAYMENT", result.data);
        }
      }
    );
    return order;
  },
  async MAKE_ABO_ORDER({ commit }) {
    const stationId = await store.getters["userSession/GET_STATION"];
    const reservation = await store.getters["reservation/GET_RESERVATION"];
    const endpositions = reservation.end_positions;
    const amount = 0; // TODO Parameter?
    const bookingPayload = await store.getters["reservation/GET_BOOKING_PAYLOAD"];

    console.log(bookingPayload, 'bookingPayload')

    const payload = {
      initialAmount: amount,
      currency: "EUR",
      transactionType: "DEBIT",
      ipAddress: null,
      async: await getPayRoutes(),
      terms: Date.now(),
      privacy: Date.now(),
      bookingData: btoa(JSON.stringify(bookingPayload))
    };
    let order = "";
    await apiCall.postConcardis(
      `/api/rent/payment/${stationId}/orders`,
      payload,
      (result) => {
        order = result;
        if (result.status === 200) {
          commit("MUTATE_PAYMENT", result.data);
        }
      }
    );
    return order;
  },
  async SET_ORDER({ commit }) {
    let order = null;
    const stationId = await store.getters["userSession/GET_STATION"];
    const payload = {};
    const payment = await store.getters["payment/GET_ORDER"];

    console.log(payment, 'SET ORDER')

    if (!payment || payment.payment_provider === "COMPUTOP") {
      const computopPayment = JSON.parse(sessionStorage.getItem(ENV + "computopPayment"));

      if (computopPayment) {
        commit("MUTATE_COMPUTOP_PAYMENT", computopPayment);
        return computopPayment;
      }
    }
    if(payment?.payment_provider === 'ADYEN') {
      if (new Date(payment.expiresAt) > new Date()) {
        return payment;
      }
      console.log('expired')
      return null;
    }

    if (payment !== null) {
      await apiCall.getConcardis(
        `/api/rent/payment/${stationId}/orders/` + payment.orderId,
        payload,
        (result) => {
          order = result.data;
          if (result.status === 200) {
            commit("MUTATE_PAYMENT", result.data);
          }
        }
      );
    }

    return order;
  },
  async REFUND_ORDER({ commit }) {
    let order = "";
    const stationId = await store.getters["userSession/GET_STATION"];
    const payment = await store.dispatch("payment/SET_ORDER");

    if (payment !== null) {
      const payload = {
        initialAmount: payment.initialAmount,
        currency: payment.currency,
      };
      const orderId = payment.orderId;
      const transactionId = payment.transactions[0].transactionId;
      await apiCall.postConcardis(
        `/api/rent/payment/${stationId}/orders/` +
          orderId +
          "/transactions/" +
          transactionId +
          "/refund",
        payload,
        (result) => {
          order = result;
        }
      );
    }
    commit("DELETE");
    return order;
  },
  DELETE_CONCARDIS({ commit }) {
    commit("DELETE");
  },
  async SET_COMPUTOP_PAYMENT({ commit }, paymentData) {
    commit("MUTATE_COMPUTOP_PAYMENT", paymentData);
  },
  DELETE_COMPUTOP({ commit }) {
    commit("DELETE_COMPUTOP");
  },
};

// mutations
const mutations = {
  MUTATE_PAYMENT(state, payment) {
    state.payment = payment;
    sessionStorage.setItem(ENV + "concardisPayment", JSON.stringify(payment));
  },
  DELETE(state) {
    delete state.payment;
    sessionStorage.removeItem(ENV + "concardisPayment");
  },
  MUTATE_COMPUTOP_PAYMENT(state, payment) {
    state.payment = payment;
    sessionStorage.setItem(ENV + "computopPayment", JSON.stringify(payment));
  },
  DELETE_COMPUTOP(state) {
    delete state.payment;
    sessionStorage.removeItem(ENV + "computopPayment");
  },
};
export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state,
};
